import { createAsyncThunk } from '@/redux/createAsyncThunk';
import { getAuthToken } from '@/redux/modules/account/user/user.selectors';
import { getIsBot } from '@/redux/modules/analytics';
import { getClientIpAddress } from '@/redux/modules/browser';
import { getDeployment } from '@/redux/modules/config';
import { fetchItemCarousels } from '@/redux/modules/itemCarousel/itemCarousel.api';
import { FetchItemCarouselsPayload } from '@/redux/modules/itemCarousel/itemCarousel.types';

type LoadChairishSimilarItemsParams = {
    itemId: number;
};

export const loadChairishSimilarItems = createAsyncThunk<FetchItemCarouselsPayload, LoadChairishSimilarItemsParams>(
    'la/domain/chairishSimilarItems/load',
    async ({ itemId }, { getState }) => {
        const state = getState();
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);
        const ipAddress = getClientIpAddress(state);
        const isBot = getIsBot(state);

        const { payload: carousels } = await fetchItemCarousels({
            authToken,
            deployment,
            ipAddress,
            isBot,
            itemId,
            useChairishSimilarItems: true,
        });

        return { carousels, itemId };
    }
);
